import BaseExtension from './base';

import {
   createElement, existy, inRange, find, addClass, removeClass, remove, map, isArray
} from '../utils';

import load from './helpers/transport';
import timeCodeToSeconds from './helpers/timeCodeToSeconds';
import createSvg, { CROSS } from '../svgs';

const OUTER_CN = 'rmp-annotation';
const OUTER_VISIBLE_CN = `${OUTER_CN}--visible`;
const OUTER_HOLDER_CN = `${OUTER_CN}__holder`;
const OUTER_BUTTON_CN = `${OUTER_CN}__button`;

const URL_REGEX = /(https?:\/\/[^\s]+)/g;
const CROSS_SIZE = 16;

export default class AnnotationsExtension extends BaseExtension {
   /** @type {Array} */
   annotations = [];
   /** @type {Array} */
   sources = [];
   /** @type {Object} */
   current = null;

   constructor(player, state, options) {
      super(player, state, options, ['timeupdate', 'annotationslang']);
      this.logger.debug('annotations:extension:creating');

      this.render();
      this.init();

      this.logger.debug('annotations:extension:created');
   }

   init() {
      this.addEvent(this.$button, 'click', () => {
         remove(this.annotations, this.current);
         removeClass(this.$outer, OUTER_VISIBLE_CN);
         this.current = null;
         this.player.focus();
      });

      const { annotations } = this.options;
      this.sources = isArray(annotations) ? annotations : [annotations];
   }

   onAnnotationslang(lang) {
      this.annotations.length = 0;
      this.current = null;
      this.onTimeupdate();
      const source = find(this.sources, s => s.srclang === lang );
      if (source) {
         load({ url: source.src, success: (resp) => {
            try {
               this.annotations = map( JSON.parse(resp.data), _convert);
               this.onTimeupdate();
            } catch (e) {
               this.logger.error('Error occurred when parsing the response', resp.data, e);
            }
         }});
      }
   }

   render() {
      /** @type {HTMLMediaElement} */
      this.$outer = createElement('div', { class: OUTER_CN } );

      this.$button = createElement('button', { type: 'button', class: OUTER_BUTTON_CN }, this.$outer);
      this.$button.setAttribute('aria-label', 'Close annotation');

      createSvg(this.$button, CROSS, { width: CROSS_SIZE, height: CROSS_SIZE });

      this.$outerHolder = createElement('div', { class: OUTER_HOLDER_CN }, this.$outer);
   }

   onTimeupdate() {
      const time = this.player.getCurrentTime();
      if ( existy(this.current) && inRange(time, this.current.from, this.current.to) ) {
         return;
      }

      this.current = find(this.annotations, ann => inRange(time, ann.from, ann.to));

      if ( existy(this.current) ) {
         _applyStyles(this.$outer, this.current);
         _insertText(this.$outerHolder, this.current.text);
         addClass(this.$outer, OUTER_VISIBLE_CN);
      } else {
         removeClass(this.$outer, OUTER_VISIBLE_CN);
      }
   }

   getOuter() {
      return this.$outer;
   }

   destroy() {
      super.destroy();

      if (this.$outer) {
         const parent = this.$outer.parentNode;
         parent.removeChild(this.$outer);
         this.$outer = null;
      }
   }
}

function _wrapURLs(text) {
   return text.replace(URL_REGEX, '<a href="$1">$1</a>');
}

function _wrapNewLine(text) {
   return text.replace(/\n/g, '<br />');
}

function _convert({ text, starts, ends, top, left, width, height, fontsize, fontcolor, background }) {
   return {
      text, top, left, width, height, fontsize, fontcolor, background,
      from: timeCodeToSeconds(`${starts.hh}:${starts.mm}:${starts.ss}`),
      to: timeCodeToSeconds(`${ends.hh}:${ends.mm}:${ends.ss}`)
   };
}

function _applyStyles(element, ann) {
   element.style.top = `${ann.top}px`;
   element.style.left = `${ann.left}px`;
   element.style.width = `${ann.width}px`;
   element.style.height = `${ann.height}px`;

   element.style.fontSize = ann.fontsize;
   element.style.color = `#${ann.fontcolor}`;
   element.style.backgroundColor = `#${ann.background}`;
}

function _insertText(element, text) {
   element.textContent = text;
   let html = _wrapURLs(element.innerHTML);
   html = _wrapNewLine(html);
   element.innerHTML = html;
}
